export default __webpack_public_path__ + "static/media/icon-down.159b155c.svg";